import { Controller } from "@hotwired/stimulus"

// Admin → MCP connections (Phelipe 2026-10-29): one tab per Claude
// connection, Feedback Loop and Support lookups. The server draws the right
// one first (?tab=support, or the half a code or key was just made in);
// picking a tab rewrites the address so a refresh keeps it.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { url: String }

  pick(e) {
    const name = e.currentTarget.dataset.tab
    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.tab === name
      tab.setAttribute("aria-selected", String(on))
      tab.classList.toggle("border-brand", on)
      tab.classList.toggle("text-brand-dark", on)
      tab.classList.toggle("font-semibold", on)
      tab.classList.toggle("border-transparent", !on)
      tab.classList.toggle("text-gray-500", !on)
    })
    this.panelTargets.forEach((panel) => { panel.hidden = panel.dataset.tab !== name })

    // After making a code or key the address is the POST's (…/keys), which a
    // refresh can't open, so start from the page's own address then.
    const onPage = window.location.pathname === this.urlValue
    const url = onPage ? new URL(window.location.href) : new URL(this.urlValue, window.location.origin)
    if (name === "support") url.searchParams.set("tab", "support"); else url.searchParams.delete("tab")
    url.hash = ""
    window.history.replaceState({}, "", url)
  }
}
